<div class="page-container dashboard-page"
     [class.dashboard-page--map-only]="isMapOnlyMode"
     [class.dashboard-page--pdf-mode]="isPdfMode"
     [attr.data-dashboard-loading]="isLoading ? 'true' : 'false'"
     [attr.data-dashboard-loaded]="hasData && !isLoading ? 'true' : 'false'">
      <div class="dashboard-map-background" *ngIf="hasData">
        <mgl-map
          class="background-map"
          [style]="'mapbox://styles/mapbox/light-v10'"
          [zoom]="[15.5]"
          [center]="mapCenter"
          [interactive]="!isPdfMode"
          [dragPan]="!isPdfMode"
          [scrollZoom]="!isPdfMode"
          [doubleClickZoom]="!isPdfMode"
          [boxZoom]="false"
          [touchZoomRotate]="!isPdfMode"
          [touchPitch]="false"
          [pitchWithRotate]="false"
          [attributionControl]="false"
          [preserveDrawingBuffer]="true"
          [accessToken]="mapboxToken">
          <mgl-geojson-source
            id="subject-polygon"
            [data]="subjectPolygonGeoJson">
          </mgl-geojson-source>

          <mgl-layer
            id="subject-polygon-fill"
            type="fill"
            source="subject-polygon"
            [paint]="{
              'fill-color': 'rgba(255, 255, 255, 0.01)',
              'fill-opacity': 1
            }">
          </mgl-layer>

          <mgl-layer
            id="subject-polygon-outline"
            type="line"
            source="subject-polygon"
            [paint]="{
              'line-color': '#4A5568',
              'line-width': 1,
              'line-opacity': 1
            }">
          </mgl-layer>

          <!-- Isochrone layers -->
          <mgl-geojson-source
            *ngIf="isochroneData"
            id="isochrone-source"
            [data]="isochroneData">
          </mgl-geojson-source>

          <!-- Inverted mask for darkening area outside isochrone -->
          <mgl-geojson-source
            *ngIf="isochroneMaskData"
            id="isochrone-mask-source"
            [data]="isochroneMaskData">
          </mgl-geojson-source>

          <mgl-layer
            *ngIf="isochroneMaskData"
            id="isochrone-mask"
            type="fill"
            source="isochrone-mask-source"
            [paint]="{
              'fill-color': 'rgba(0, 0, 0, 0.05)',
              'fill-opacity': 1
            }">
          </mgl-layer>

          <mgl-layer
            *ngIf="isochroneData"
            id="isochrone-fill"
            type="fill"
            source="isochrone-source"
            [paint]="{
              'fill-color': '#f9fafb',
              'fill-opacity': 0.2
            }">
          </mgl-layer>

          <mgl-layer
            *ngIf="isochroneData"
            id="isochrone-outline"
            type="line"
            source="isochrone-source"
            [paint]="{
              'line-color': '#48515B',
              'line-width': 1,
              'line-opacity': 0.8,
              'line-dasharray': [4, 4]
            }">
          </mgl-layer>

          <!-- Polygon vertex points -->
          <mgl-geojson-source
            *ngIf="subjectPolygonFeatures.length > 0"
            id="plot-sizes-points"
            [data]="
              subjectPolygonFeatures
                | polygonToSimplifyPolygon: !detailedSettings.isShowDetailedDimensions
                | polygonToPoints
            ">
          </mgl-geojson-source>

          <mgl-layer
            *ngIf="subjectPolygonFeatures.length > 0 && detailedSettings.isShowBoundaries"
            id="plot-sizes-points-layer"
            type="circle"
            source="plot-sizes-points"
            [paint]="{
              'circle-color': '#48515B',
              'circle-radius': 3,
              'circle-stroke-width': 0
            }">
          </mgl-layer>

          <!-- Polygon vertex labels (numbers) -->
          <mgl-geojson-source
            *ngIf="subjectPolygonFeatures.length > 0"
            id="plot-vertex-source"
            [data]="
              subjectPolygonFeatures
                | polygonToSimplifyPolygon: !detailedSettings.isShowDetailedDimensions
                | polygonToVertexLabelsArray: null
            ">
          </mgl-geojson-source>

          <mgl-layer
            *ngIf="subjectPolygonFeatures.length > 0"
            id="plot-vertex-layer"
            type="symbol"
            source="plot-vertex-source"
            [layout]="{
              'symbol-placement': 'point',
              'text-field': '{index}',
              'text-size': 14,
              'text-offset': ['get', 'text-offset'],
              'text-rotation-alignment': 'map',
              'text-pitch-alignment': 'map',
              'text-keep-upright': true,
            }"
            [paint]="{
              'text-color': '#48515B',
            }">
          </mgl-layer>

          <!-- Polygon edge labels (distances and bearings) -->
          <mgl-geojson-source
            *ngIf="subjectPolygonFeatures.length > 0"
            id="plot-sizes-lines"
            [data]="
              subjectPolygonFeatures
                | polygonToSimplifyPolygon: !detailedSettings.isShowDetailedDimensions
                | polygonToLines
                | linesToBearingLines: detailedSettings.isShowNorthAngle
            ">
          </mgl-geojson-source>

          <mgl-layer
            *ngIf="!isPdfMode && subjectPolygonFeatures.length > 0"
            id="plot-sizes-sizes"
            type="symbol"
            source="plot-sizes-lines"
            [layout]="{
              'symbol-placement': 'line-center',
              'text-field': '{distance}',
              'text-size': 12,
              'text-ignore-placement': true,
              'text-allow-overlap': true,
              'text-offset': [0, -0.8],
              'text-rotation-alignment': 'map',
              'text-pitch-alignment': 'map',
              'text-keep-upright': true,
            }"
            [paint]="{
              'text-halo-width': 1,
              'text-halo-blur': 0,
              'text-halo-color': 'rgba(255, 255, 255, 0.5)',
            }">
          </mgl-layer>
        </mgl-map>
      </div>

      <div class="dashboard-toolbar-container" *ngIf="!isPdfMode && !isMapOnlyMode">
        <app-dashboard-toolbar 
          (reportChanged)="onReportChanged($event)"
          (exportPdfClick)="exportToPdf()"
          (settingsChange)="onSettingsChange($event)"
          (toggleCaseAssetInfo)="onToggleCaseAssetInfo()">
        </app-dashboard-toolbar>
      </div>
      <div class="dashboard-container" *ngIf="!isMapOnlyMode" [class.dashboard-container--error]="!!errorMessage">
        <!-- Print Mode Logo -->
        <div class="print-mode-logo" *ngIf="isPdfMode">
          <img src="assets/img/brand/logo-perare-mono.svg" alt="Perare" />
        </div>
        
        <div class="dashboard-content">
        <!-- Subject Property Info -->
        <!--
        <app-subject-property-header 
          *ngIf="hasData && subjectPropertyData && shouldShowWidget('subject-property')" 
          [data]="subjectPropertyData">
        </app-subject-property-header>
        -->

        <!-- Case/Asset Info Card -->
        <app-case-asset-info-card
          *ngIf="showCaseAssetInfo || isPdfMode"
          [caseData]="caseData"
          [assetData]="assetData"
          [printMode]="isPdfMode"
          (close)="onToggleCaseAssetInfo()">
        </app-case-asset-info-card>

        <!-- Valuation Commentary (print/PDF mode only) -->
        <div class="valuation-commentary" *ngIf="isPdfMode">
          <div class="commentary-header">
            <span class="commentary-icon" aria-hidden="true">
              <svg viewBox="0 0 20 20" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5" />
                <path d="M10 6.2v0.6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M10 9.2v4.6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </span>
            <span class="commentary-title">{{ 'valuation_commentary_title' | translate }}</span>
          </div>
          <div class="commentary-body">
            <p>{{ 'valuation_commentary_line_1' | translate }}</p>
            <p>{{ 'valuation_commentary_line_2' | translate }}</p>
            <p>{{ 'valuation_commentary_line_3' | translate }}</p>
            <p class="commentary-secondary">{{ 'valuation_commentary_line_4' | translate }}</p>
          </div>
        </div>

        <!-- Metrics Row: 3 widgets in a row with space for map on the right -->
        <div class="metrics-row" *ngIf="shouldShowWidget('market-value') || shouldShowWidget('fsv') || shouldShowWidget('reliability')">
          <!-- Market Value -->
          <app-market-value-card 
            *ngIf="shouldShowWidget('market-value')"
            [data]="marketValueData"
            [isLoading]="isLoading || !marketValueData">
          </app-market-value-card>

          <!-- Forced Sale Value -->
          <app-fsv-card 
            *ngIf="shouldShowWidget('fsv')"
            [data]="fsvData"
            [isLoading]="isLoading || !fsvData">
          </app-fsv-card>

          <!-- Reliability -->
          <app-reliability-card 
            *ngIf="shouldShowWidget('reliability')"
            [data]="reliabilityData"
            [isLoading]="isLoading || !reliabilityData">
          </app-reliability-card>
        </div>

        <!-- Map in print mode - show between widgets and table -->
        <div class="dashboard-map-print" *ngIf="isPdfMode && hasData">
          <mgl-map
            #printMapComponent
            class="print-map"
            [style]="'mapbox://styles/mapbox/light-v10'"
            [zoom]="[15.5]"
            [center]="mapCenter"
            [fitBounds]="polygonBounds"
            [fitBoundsOptions]="printModeFitBoundsOptions"
            [interactive]="false"
            [dragPan]="false"
            [scrollZoom]="false"
            [doubleClickZoom]="false"
            [boxZoom]="false"
            [touchZoomRotate]="false"
            [touchPitch]="false"
            [pitchWithRotate]="false"
            [attributionControl]="false"
            [preserveDrawingBuffer]="true"
            [accessToken]="mapboxToken">
            <mgl-geojson-source
              id="subject-polygon-print"
              [data]="subjectPolygonGeoJson">
            </mgl-geojson-source>

            <mgl-layer
              id="subject-polygon-fill-print"
              type="fill"
              source="subject-polygon-print"
              [paint]="{
                'fill-color': 'rgba(255, 255, 255, 0.01)',
                'fill-opacity': 1
              }">
            </mgl-layer>

            <mgl-layer
              id="subject-polygon-outline-print"
              type="line"
              source="subject-polygon-print"
              [paint]="{
                'line-color': '#4A5568',
                'line-width': 1,
                'line-opacity': 1
              }">
            </mgl-layer>

            <!-- Isochrone layers -->
            <mgl-geojson-source
              *ngIf="isochroneData"
              id="isochrone-source-print"
              [data]="isochroneData">
            </mgl-geojson-source>

            <mgl-geojson-source
              *ngIf="isochroneMaskData"
              id="isochrone-mask-source-print"
              [data]="isochroneMaskData">
            </mgl-geojson-source>

            <mgl-layer
              *ngIf="isochroneMaskData"
              id="isochrone-mask-print"
              type="fill"
              source="isochrone-mask-source-print"
              [paint]="{
                'fill-color': 'rgba(0, 0, 0, 0.05)',
                'fill-opacity': 1
              }">
            </mgl-layer>

            <mgl-layer
              *ngIf="isochroneData"
              id="isochrone-fill-print"
              type="fill"
              source="isochrone-source-print"
              [paint]="{
                'fill-color': '#f9fafb',
                'fill-opacity': 0.2
              }">
            </mgl-layer>

            <mgl-layer
              *ngIf="isochroneData"
              id="isochrone-outline-print"
              type="line"
              source="isochrone-source-print"
              [paint]="{
                'line-color': '#48515B',
                'line-width': 1,
                'line-opacity': 0.8,
                'line-dasharray': [4, 4]
              }">
            </mgl-layer>
          </mgl-map>
        </div>
        
        <!-- Loading State - Only show for critical errors or initial load when no widgets are visible -->
        <div class="loading-state" *ngIf="isLoading && errorMessage">
          <div class="perare-loader-content">
            <svg
              class="animate-spin"
              width="32px"
              height="32px"
              viewBox="0 0 46 46"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_loader)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M31.4853 31.4853C35.9335 27.0371 36.1595 19.9654 32.1632 15.2507C31.806 14.8294 31.8019 14.1982 32.1924 13.8077C32.5829 13.4171 33.2198 13.4156 33.5818 13.8326C38.3565 19.3325 38.1291 27.67 32.8995 32.8995C27.4322 38.3669 18.5678 38.3669 13.1005 32.8995C7.87095 27.67 7.64351 19.3325 12.4182 13.8326C12.7802 13.4156 13.4171 13.4171 13.8076 13.8077C14.1981 14.1982 14.194 14.8294 13.8369 15.2507C9.84052 19.9654 10.0665 27.0371 14.5147 31.4853C19.201 36.1716 26.799 36.1716 31.4853 31.4853Z"
                  fill="#014FCF"
                />
              </g>
              <defs>
                <clipPath id="clip0_loader">
                  <rect
                    width="32"
                    height="32"
                    fill="white"
                    transform="translate(23 45.6274) rotate(-135)"
                  />
                </clipPath>
              </defs>
            </svg>

            <svg
              width="96"
              height="25"
              viewBox="0 0 96 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.35236 3.72539C4.96801 2.92694 5.80656 2.25456 6.86802 1.70825C7.92948 1.16195 9.12893 0.888794 10.4664 0.888794C11.9949 0.888794 13.3854 1.26701 14.6379 2.02343C15.9117 2.75885 16.9094 3.79894 17.6312 5.1437C18.353 6.48846 18.7139 8.03283 18.7139 9.77681C18.7139 11.5208 18.353 13.0862 17.6312 14.473C16.9094 15.8387 15.9117 16.9103 14.6379 17.6878C13.3854 18.4442 11.9949 18.8224 10.4664 18.8224C9.12893 18.8224 7.9401 18.5598 6.89987 18.0345C5.85964 17.4882 5.01047 16.8158 4.35236 16.0173V24.9999H0.722168L0.722168 3.17383H4.35236V3.72539ZM15.02 9.77681C15.02 8.57914 14.7653 7.54955 14.2558 6.68807C13.7675 5.80557 13.1094 5.1437 12.2815 4.70245C11.4748 4.24019 10.6044 4.00906 9.67028 4.00906C8.75742 4.00906 7.88703 4.24019 7.05909 4.70245C6.25238 5.16471 5.59427 5.83709 5.08477 6.71959C4.5965 7.60208 4.35236 8.64217 4.35236 9.83985C4.35236 11.0375 4.5965 12.0881 5.08477 12.9916C5.59427 13.8741 6.25238 14.5465 7.05909 15.0088C7.88703 15.471 8.75742 15.7022 9.67028 15.7022C10.6044 15.7022 11.4748 15.471 12.2815 15.0088C13.1094 14.5255 13.7675 13.8321 14.2558 12.9286C14.7653 12.0251 15.02 10.9745 15.02 9.77681Z"
                fill="#0E1217"
              />
              <path
                d="M37.7481 9.43012C37.7481 10.0815 37.7056 10.6698 37.6207 11.1951H24.2144C24.3206 12.5819 24.8407 13.6955 25.7748 14.536C26.7089 15.3765 27.8552 15.7967 29.2139 15.7967C31.167 15.7967 32.5469 14.9878 33.3536 13.3698H37.2704C36.7397 14.9667 35.7737 16.28 34.3726 17.3096C32.9927 18.3181 31.2731 18.8224 29.2139 18.8224C27.5368 18.8224 26.0295 18.4547 24.6921 17.7193C23.3759 16.9629 22.3357 15.9123 21.5714 14.5675C20.8284 13.2017 20.4569 11.6259 20.4569 9.83985C20.4569 8.05384 20.8178 6.48846 21.5396 5.1437C22.2826 3.77793 23.3122 2.72733 24.6284 1.99192C25.9659 1.2565 27.4944 0.888794 29.2139 0.888794C30.8698 0.888794 32.3452 1.246 33.6402 1.9604C34.9352 2.6748 35.9436 3.68337 36.6654 4.98611C37.3872 6.26783 37.7481 7.74917 37.7481 9.43012ZM33.9586 8.29548C33.9374 6.97173 33.4598 5.91063 32.5257 5.11218C31.5916 4.31373 30.4346 3.9145 29.0547 3.9145C27.8022 3.9145 26.7301 4.31373 25.8385 5.11218C24.9468 5.88962 24.4161 6.95072 24.2463 8.29548H33.9586Z"
                fill="#0E1217"
              />
              <path
                d="M43.1993 3.69388C43.73 2.81138 44.4306 2.12849 45.301 1.64522C46.1926 1.14094 47.2435 0.888794 48.4535 0.888794V4.60789H47.5301C46.1077 4.60789 45.025 4.96509 44.282 5.6795C43.5602 6.3939 43.1993 7.6336 43.1993 9.3986V18.5388H39.5691V3.09504H43.1993V3.69388Z"
                fill="#0E1217"
              />
              <path
                d="M60.6628 7.56158C60.6628 6.42169 60.3403 5.54397 59.6953 4.92843C59.0734 4.29009 58.2097 3.97092 57.1041 3.97092C56.0675 3.97092 55.1692 4.2103 54.4091 4.68905C53.672 5.16781 53.1423 5.94294 52.8198 7.01444L49.7102 5.71496C50.1479 4.32429 51.0001 3.20719 52.267 2.36367C53.5569 1.52015 55.2153 1.09839 57.2423 1.09839C58.6012 1.09839 59.8105 1.32636 60.8701 1.78232C61.9526 2.21548 62.7934 2.88802 63.3922 3.79993C64.0142 4.68905 64.3251 5.81755 64.3251 7.18542V14.8113C64.3251 15.6548 64.7512 16.0766 65.6035 16.0766C66.0181 16.0766 66.4212 16.0196 66.8128 15.9056L66.6054 18.4362C66.0757 18.6869 65.4077 18.8123 64.6015 18.8123C63.6802 18.8123 62.8855 18.6072 62.2175 18.1968C61.5496 17.7864 61.1004 17.1709 60.8701 16.3502C60.3172 17.1937 59.5226 17.832 58.4861 18.2652C57.4496 18.6755 56.413 18.8807 55.3765 18.8807C53.7411 18.8807 52.3821 18.4932 51.2996 17.718C50.217 16.9429 49.6757 15.7802 49.6757 14.23C49.6757 12.9761 50.0903 11.9388 50.9195 11.1181C51.7717 10.2973 52.9695 9.72738 54.5128 9.40821L60.6628 8.21132V7.56158ZM53.4071 13.9564C53.4071 14.5947 53.649 15.1077 54.1327 15.4952C54.6394 15.86 55.3074 16.0424 56.1366 16.0424C56.9198 16.0424 57.6569 15.917 58.3479 15.6662C59.0389 15.4155 59.5917 15.0051 60.0063 14.4351C60.4439 13.8652 60.6628 13.1243 60.6628 12.2123V10.7761L56.3094 11.6652C55.3189 11.8476 54.5819 12.1098 54.0982 12.4517C53.6375 12.7937 53.4071 13.2952 53.4071 13.9564Z"
                fill="#0E1217"
              />
              <path
                d="M72.2051 3.69388C72.7359 2.81138 73.4364 2.12849 74.3068 1.64522C75.1985 1.14094 76.2493 0.888794 77.4594 0.888794V4.60789H76.5359C75.1135 4.60789 74.0309 4.96509 73.2878 5.6795C72.566 6.3939 72.2051 7.6336 72.2051 9.3986V18.5388H68.575V3.09504H72.2051V3.69388Z"
                fill="#0E1217"
              />
              <path
                d="M95.4444 9.43012C95.4444 10.0815 95.4019 10.6698 95.317 11.1951H81.9108C82.0169 12.5819 82.537 13.6955 83.4711 14.536C84.4052 15.3765 85.5516 15.7967 86.9103 15.7967C88.8633 15.7967 90.2432 14.9878 91.05 13.3698H94.9667C94.436 14.9667 93.4701 16.28 92.069 17.3096C90.6891 18.3181 88.9695 18.8224 86.9103 18.8224C85.2332 18.8224 83.7259 18.4547 82.3884 17.7193C81.0722 16.9629 80.032 15.9123 79.2677 14.5675C78.5247 13.2017 78.1532 11.6259 78.1532 9.83985C78.1532 8.05384 78.5141 6.48846 79.2359 5.1437C79.9789 3.77793 81.0085 2.72733 82.3247 1.99192C83.6622 1.2565 85.1907 0.888794 86.9103 0.888794C88.5661 0.888794 90.0416 1.246 91.3365 1.9604C92.6315 2.6748 93.6399 3.68337 94.3617 4.98611C95.0835 6.26783 95.4444 7.74917 95.4444 9.43012ZM91.655 8.29548C91.6338 6.97173 91.1561 5.91063 90.222 5.11218C89.2879 4.31373 88.1309 3.9145 86.751 3.9145C85.4985 3.9145 84.4264 4.31373 83.5348 5.11218C82.6432 5.88962 82.1125 6.95072 81.9426 8.29548H91.655Z"
                fill="#0E1217"
              />
            </svg>
          </div>
        </div>

        <div class="error-state" *ngIf="errorMessage">
          <div class="error-icon-wrapper">
            <app-ui-icon-x [iconName]="'LogoError'" [size]="32" [color]="'#9C9C9D'"></app-ui-icon-x>
          </div>
          <h3>We’re having technical difficulties</h3>
          <p>We’ll have things running smoothly again soon.</p>
        </div>

        <!-- Comparable Properties Table (Full Width) -->
        <div class="comparable-section" *ngIf="shouldShowWidget('comparable-properties')">
            <div class="section-header">
              <div>
                <h3>{{ 'appreciation_rate_title' | translate }}</h3>
              <!-- <p>Recent sales used to calculate market value</p> -->
              </div>
            </div>

            <!-- Skeleton Placeholder -->
            <div class="comparable-skeleton" *ngIf="isLoading || !hasData">
              <app-x-placeholder-row>
                <app-x-placeholder-fixed-loader [width]="'100px'" [height]="'20px'"></app-x-placeholder-fixed-loader>
                <app-x-placeholder-flexible-loader [grow]="1"></app-x-placeholder-flexible-loader>
              </app-x-placeholder-row>
              
              <app-x-placeholder-row *ngFor="let i of [1,2]">
                <app-x-placeholder-fixed-loader [width]="'100px'" [height]="'20px'"></app-x-placeholder-fixed-loader>
                <app-x-placeholder-flexible-loader [grow]="1"></app-x-placeholder-flexible-loader>
                <app-x-placeholder-fixed-loader [width]="'60px'" [height]="'20px'"></app-x-placeholder-fixed-loader>
                <app-x-placeholder-flexible-loader [grow]="1"></app-x-placeholder-flexible-loader>
              </app-x-placeholder-row>
            </div>

            <!-- Content when loaded -->
            <ng-container *ngIf="!isLoading && hasData">
            <div class="comparable-meta">
              <div class="meta-item">
                <span class="meta-label">{{ 'appreciation_rate_time_window' | translate }}:</span>
                <span class="meta-chip">{{ getTranslatedTimeWindow() }}</span>
              </div>
              <div class="meta-item">
                <span class="meta-label">{{ 'appreciation_rate_distance' | translate }}:</span>
                <span class="meta-chip">{{ getTranslatedDistance() }}</span>
              </div>
            </div>

            <!-- Empty state when no comparables -->
            <div class="comparable-empty-state" *ngIf="comparableProperties.length === 0">
              <p class="empty-message">
                {{ (comparablePropertiesWarning?.message) || ('appreciation_rate_no_comparisons' | translate) }}
              </p>
              <ul class="empty-suggestions" *ngIf="comparablePropertiesWarning && comparablePropertiesWarning.suggestions && comparablePropertiesWarning.suggestions.length > 0">
                <li *ngFor="let suggestion of comparablePropertiesWarning.suggestions">
                  {{ suggestion }}
                </li>
              </ul>
            </div>

            <!-- Table when comparables are available -->
            <div class="comparable-table" *ngIf="comparableProperties.length > 0">
              <table>
                <thead>
                  <tr>
                    <th>{{ 'appreciation_rate_table_address' | translate }}</th>
                    <th>{{ 'appreciation_rate_table_area' | translate }}</th>
                    <th>{{ 'appreciation_rate_table_total_price' | translate }}</th>
                    <th>{{ 'appreciation_rate_table_price_per_sqm' | translate }}</th>
                    <th>{{ 'appreciation_rate_table_distance' | translate }}</th>
                    <th>{{ 'appreciation_rate_table_date' | translate }}</th>
                    <th>{{ 'appreciation_rate_table_similarity' | translate }}</th>
                    <th>{{ 'appreciation_rate_table_adj_price' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let comp of comparableProperties; trackBy: trackComparable" 
                      (click)="flyToComparable(comp)"
                      [class.selected-row]="selectedComparable === comp"
                      style="cursor: pointer;">
                    <td>
                      <div class="address-cell">
                        <!--
                        <span class="selection-dot" [class.selected]="comp.selected"></span>
                        -->
                        <div class="address-text">
                          <div class="street">{{ comp.address }}</div>
                        </div>
                      </div>
                    </td>
                    <td>{{ comp.area }}</td>
                    <td>{{ comp.totalPrice }}</td>
                    <td>{{ comp.pricePerSqm }}</td>
                    <td>{{ comp.distance }}m</td>
                    <td>{{ comp.date }}</td>
                    <td>
                      <div class="similarity-badge" [class.high]="comp.similarity >= 80" [class.medium]="comp.similarity >= 60 && comp.similarity < 80" [class.low]="comp.similarity < 60">
                        {{ comp.similarity }}%
                      </div>
                    </td>
                    <td>{{ comp.adjustedPrice }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            </ng-container>
          </div>

        <!-- Print disclaimer (print/PDF mode only) -->
        <div class="print-disclaimer" *ngIf="isPdfMode">
          {{ 'valuation_commentary_disclaimer' | translate }}
        </div>
        </div>
      </div>
    </div>
